import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

/**
 * Capture the beforeinstallprompt event early — before Angular bootstraps —
 * so it's never missed. The InstallPromptComponent reads from this global.
 */
window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  (window as any).__pwaInstallPromptEvent = e;
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
